import React from 'react';

import { Table } from 'components';

const ChatGroupList = props => {
  return (
    <div style={{ width: 500 }}>
      <Table
        columns={[
          {
            title: 'Name',
            field: 'name',
            defaultSort: 'desc',
          },
        ]}
        data={props.data}
      />
    </div>
  );
};

export default ChatGroupList;
